<template>
	<Container>
		<h3 class="title">聯係我們</h3>
		<div class="content">
			<div class="menu">
		        <div class="menu-item" :class='{active:activeCode == menu.Code}' v-for='menu in list' @click='select(menu.Code)'>
		          <Icon type="ios-paper" class='icon'></Icon>{{menu.Title}}
		        </div>
		      </div>
			<div class="desc">
				<div class="html" v-html='article.Content'></div>
			</div>
		</div>
	</Container>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				list:[],
				article:{},
				activeCode:null,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getCommunityListAction',
				'getCommunityArticleAction',
			]),
			async initData(){
				let params = {
					code:'DT_WS_ContactCatalog',
					depth:1,
					keys: '',
					StartIndex: 1,
					PageSize: 20,
				}
				this.list = await this.getCommunityListAction(params)
				this.activeCode = this.list[0].Code
				this.article = await this.getCommunityArticleAction({Code:this.activeCode})

			},
			async select(Code) {
		      this.activeCode = Code
		      this.article = await this.getCommunityArticleAction({Code})
		      this.show = false
		    },
		},
	}
</script>

<style lang='scss' scoped>
	@import 'src/style/common';
	.title {
		margin:30px auto;
		text-align: center;
		@include fontSize($font-size-24);
		color:$theme-color;
	}
	.content {
		margin:40px auto;
		display: flex;
		max-width: 1200px;
		.desc {
			flex:1;
			margin-left:40px ;
		}
		.map-box {
			width: 40vw;
			#l-map {
				width: 40vw;
				height:30vw;
			}
		}
	}
	.menu {
      width: 240px;
      max-height: 100vh;
      overflow-y:scroll;
      .menu-item {
        cursor: pointer;
        padding: 14px 24px;
        border-right: 1px solid #ddd;
        .icon {
          margin-right: 6px;
        }
      }
      .active {
        color: #B176C5;
        background: #fef0ff;
        border-right: 2px solid #B176C5;
      }
    }
	.position {
		position: absolute;
		width: 18px;
		height: 29px;
		cursor: pointer;
	}
</style>